import { render, staticRenderFns } from "./claim-table.component.vue?vue&type=template&id=1a0ad28a&"
import script from "./claim-table.component.vue?vue&type=script&lang=ts&"
export * from "./claim-table.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports